import { Form } from "react-bootstrap";
import {useFormContext} from "react-hook-form";

export default function AcessoAoSistema({disabled}: { disabled?: boolean }) {
    const {
        register,
    } = useFormContext();
    
    return (
        <>
            <h6 className="fw-bold mb-3">Acesso ao Sistema</h6>
            <Form.Check
                type="switch"
                id="isSemAcesso"
                label="Usuário não terá acesso ao sistema"
                className="mb-2"
                {...register("isSemAcesso")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="isSngpc"
                label="Responsável Técnico SNGPC"
                className="mb-2"
                {...register("isSngpc")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="acessaRetaguarda"
                label="Usuario terá acesso ao retaguarda"
                className="mb-2"
                {...register("acessaRetaguarda")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="alternaBalcaoCaixa"
                label="Permite alternar entre balcão e caixa"
                className="mb-2"
                {...register("alternaBalcaoCaixa")}
                disabled={disabled}
            />
            <div>
                <Form.Check
                    type="switch"
                    id="acessoAdm"
                    label="Permite acessar funções administrativas"
                    className="mb-0"
                    {...register("acessoAdm")}
                    disabled={disabled}
                />
                <small className="text-body-secondary ms-4 ps-2">
                    Acesso total ao PDV, independente do grupo de permissões.
                </small>
            </div>
        </>
    )
}